import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Login from './pages/Login';
import MainPage from './pages/MainPage';
import AdminPage from './pages/AdminPage';
import LogsPage from './pages/LogsPage';
import ProtectionPage from './pages/ProtectionPage';
import './styles.scss';
import "leaflet/dist/leaflet.css";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
    return (
        <AuthProvider>
        <ToastContainer />

        <Router>
            <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/login" element={<Login />} />
                <Route path="/home" element={<MainPage key={window.location.pathname} />} />
                <Route path="/admin" element={<AdminPage />} />
                <Route path="/logs" element={<LogsPage />} />
                <Route path="/protection/:item_id" element={<ProtectionPage />} />
            </Routes>
        </Router>
        </AuthProvider>

    );
}

export default App;
